// Breakpoints
const breakpoints = {
	xs: "320",
	sm: "640",
	md: "768",
	lg: "1024",
	xl: "1280",
	xxl: "1536",
};

export const devices = {
	xs: `(min-width: ${breakpoints.xs}px)`,
	sm: `(min-width: ${breakpoints.sm}px)`,
	md: `(min-width: ${breakpoints.md}px)`,
	lg: `(min-width: ${breakpoints.lg}px)`,
	xl: `(min-width: ${breakpoints.xl}px)`,
	xxl: `(min-width: ${breakpoints.xxl}px)`,
	_sm: `(max-width: ${breakpoints.sm - 1}px)`,
	_md: `(max-width: ${breakpoints.md - 1}px)`,
	_lg: `(max-width: ${breakpoints.lg - 1}px)`,
};

// Parameters
export const DoughnutChartOptions = {
	plugins: {
		legend: {
			padding: 80,
			display: false,
			position: "bottom",
			align: "right",
			textDirection: "ltr",
			labels: {
				usePointStyle: true,
			},
		},
	},
	responsive: true,
	maintainAspectRatio: true,
	cutout: "80%",
	animation: {
		animateRotate: true,
		animateScale: true,
	},
};

export const CustomDoughnutOptions = {
	plugins: {
		legend: {
			padding: 80,
			display: false,
			position: "bottom",
			align: "right",
			textDirection: "ltr",
			labels: {
				usePointStyle: true,
			},
		},
	},
	responsive: true,
	maintainAspectRatio: true,
	cutout: "60%",
	animation: {
		animateRotate: true,
		animateScale: true,
	},
};

// Form Options
export const leaseTypeArray = ["Quick Lease", "Sponsored Lease"];
export const LeaseStructureArray = ["Lease To Own", "Operating Lease"];
export const DeliveryTypeArray = ["door delivery", "pickup"];
export const DurationTypeOptions = ["monthly", "quarterly", "semi-annually", "annually"];
export const DurationOptions = [
	"1 week",
	"2 weeks",
	"3 weeks",
	"1 month",
	"2 months",
	"3 months",
	"4 months",
	"5 months",
	"6 months",
	"7 months",
	"8 months",
	"9 months",
	"10 months",
	"11 months",
	"12 months",
	"18 months",
	"2 years",
	"3 years",
	"4 years",
	"5 years",
];

export const shelfLife = [
	"1 month",
	"2 months",
	"3 months",
	"4 months",
	"5 months",
	"6 months",
	"7 months",
	"8 months",
	"9 months",
	"10 months",
	"11 months",
	"12 months",
	"13 months",
	"14 months",
	"15 months",
	"16 months",
	"17 months",
	"18 months",
	"19 months",
	"20 months",
	"21 months",
	"22 months",
	"23 months",
	"24 months",
	"25 months",
	"26 months",
	"27 months",
	"28 months",
	"29 months",
	"30 months",
	"31 months",
	"32 months",
	"33 months",
	"34 months",
	"35 months",
	"36 months",
	"37 months",
	"38 months",
	"39 months",
	"40 months",
	"41 months",
	"42 months",
	"43 months",
	"44 months",
	"45 months",
	"46 months",
	"47 months",
	"48 months",
	"49 months",
	"50 months",
	"51 months",
	"52 months",
	"53 months",
	"54 months",
	"55 months",
	"56 months",
	"57 months",
	"58 months",
	"59 months",
	"60 months",
];

export const MaintenanceScheduleOptions = [
	"1 month",
	"2 months",
	"3 months",
	"4 months",
	"5 months",
	"6 months",
]

export const PaymentTypeOptions = ["card", "bank"];
